import * as React from "react";
import { forwardRef, memo } from "react";
const SvgBe = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 45 39", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#ED2939", d: "M0 0h45v39H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#FAE042", d: "M0 0h30v39H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h15v39H0z" }));
const ForwardRef = forwardRef(SvgBe);
const Memo = memo(ForwardRef);
export default Memo;
